import { render } from "./createNewTask.vue?vue&type=template&id=13058a53"
import script from "./createNewTask.vue?vue&type=script&lang=js"
export * from "./createNewTask.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__